import md5 from "js-md5";
import { defaultMonitor, defaultSource } from "@/store/module-simulator/lib/monitors";
import { mapActions } from "vuex";

const methods = {
    geometryBordered: function (objeto) {
        const content = {
            stroke: "#3eb772",
        };
        return Object.assign(content, objeto);
    },
    ...mapActions("simulator", [
        "GeometryListAppendAction",
        "setGeometryList",
        "updateState",
        "setDrawingStatusAction",
        "setKonvaStageAction",
        "setState",
        "setSelectedTokenAction",
        "setCurrentGeometryAction",
        "ZOOM",
        "keyPressAction",
        "keySolveAction",
        "GeometryListRemove",
        "setCurrentGeometryData",
        "setCurrentGeometrySizeWidth",
        "setCurrentGeometrySizeHeight",
        "setCurrentGeometryRadius",
        "SourcesListAppend",
        "setCurrentGeometryPosX",
        "setCurrentGeometryPosY",
        "FluxListAppend",
        "setCurrentGeometryRotation"
    ]),
    mouseDownEvent: function (event) {
        if (this.mode === "create") {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            this.setSelectedTokenAction("");
            this.updateTransformer();
            stage.stopDrag();
            this.InicioDesenho(event);
            this.setKonvaStageAction(this.$refs.transformer.getNode().getStage());
        } else if (this.mode === "sources") {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            this.setSelectedTokenAction("");
            this.updateTransformer();
            stage.stopDrag();
            this.addSource(event);
            this.setKonvaStageAction(this.$refs.transformer.getNode().getStage());
        } else if (this.mode === "flux") {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            this.setSelectedTokenAction("");
            this.updateTransformer();
            stage.stopDrag();
            this.addSource(event, true);
            this.setKonvaStageAction(this.$refs.transformer.getNode().getStage());
        } else if (this.mode === "zoom") {
            this.ZOOM(event);
        } else if (this.mode === "transform") {
            this.setSelectedTokenAction("");
        }
    },

    mouseDownTransformEvent: function (event) {
        if (this.mode === "transform") {
            this.Transformer(event);
            this.setKonvaStageAction(this.$refs.transformer.getNode().getStage());
        }
    },
    handleTransformStart: function (e) {
        this.currentStart = {
            width: e.target.size().width,
            scaleX: e.target.scaleX(),
        };
    },

    handleTransform: function (e) {
        const node = e.target;
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        if (node.attrs.shape == "block") {
            this.setCurrentGeometrySizeWidth(node.width() * scaleX);
            this.setCurrentGeometrySizeHeight(node.height() * scaleY);
        } else if (node.attrs.shape == "sphere" || node.attrs.shape == "triangle") {
            // Círculo e triângulo são descritos só pelo raio: a escala é sempre proporcional
            // (não altera width/height: no Konva, definir width nessas formas sobrescreve o raio)
            this.setCurrentGeometryRadius(
                Math.abs(node.attrs.radius * Math.max(Math.abs(scaleX), Math.abs(scaleY)))
            );
        }
        // O tamanho fica no dado; o nó volta à escala 1 para o canvas não aplicar a escala duas vezes
        node.scaleX(1);
        node.scaleY(1);
        // Redimensionar por uma âncora esquerda/superior também move a geometria
        this.setCurrentGeometryPosX(Number(node.x().toFixed(2)));
        this.setCurrentGeometryPosY(Number(node.y().toFixed(2)));
        this.setCurrentGeometryRotation(parseFloat(node.rotation().toFixed(3)));
    },
    handleDrag: function (e) {
        this.setCurrentGeometryPosX(Number(e.currentTarget.attrs.x.toFixed(2)));
        this.setCurrentGeometryPosY(Number(e.currentTarget.attrs.y.toFixed(2)));
    },
    addSource: function (event, flux = false) {
        const stage = event.target.getStage();
        const pos = stage.getPointerPosition();
        const scale = stage.scaleX();
        const params = {
            token: md5.hex(Date.now().toString()),
            x: (pos.x - stage.x()) / scale,
            y: (pos.y - stage.y()) / scale
        };

        if (flux) {
            // A faixa espectral padrão fica centrada no comprimento de onda da primeira fonte
            const firstSource = this.SourcesList[0];
            this.FluxListAppend(defaultMonitor({
                ...params,
                index: this.FluxList.length + 1,
                wavelength: firstSource ? Number(firstSource.waveLength) : undefined
            }));
        } else {
            this.SourcesListAppend(defaultSource({ ...params, index: this.SourcesList.length + 1 }));
        }
    },
    // Mantém fontes e monitores dentro da célula ao arrastar (coordenadas absolutas do Konva)
    boundToCell: function (pos) {
        const stage = this.$refs.transformer.getNode().getStage();
        const cell = stage.findOne("#mainRect");
        const origin = cell.absolutePosition();
        const scale = stage.scaleX();
        return {
            x: Math.min(Math.max(pos.x, origin.x), origin.x + this.dimensions.width * scale),
            y: Math.min(Math.max(pos.y, origin.y), origin.y + this.dimensions.height * scale)
        };
    },
    InicioDesenho: function (event) {
        if (this.mode != "create") return false;
        if (this.drawing) return false;
        let token = md5.hex(Date.now().toString());
        var oldScale = event.target.getStage().scaleX();
        var pointer = event.target.getStage().getPointerPosition();

        var PosicaoInicial = {
            x: (pointer.x - event.target.getStage().x()) / oldScale,
            y: (pointer.y - event.target.getStage().y()) / oldScale,
        };


        this.setCurrentGeometryAction({
            name: this.shape + " " + (this.GeometryList.length + 1),
            token: token,
            x: PosicaoInicial.x,
            y: PosicaoInicial.y,
            fill: this.color,
            shape: this.shape,
            epsilon: 12,
            class: "geometry",
            width: 0,
            height: 0,
            materialId: 0,
            radius: 0,
            rotation: 0,
            scaleX: 1,
            scaleY: 1,
            geometricFill: {
                properties: {
                    name: `Default ${this.shape + " " + (this.GeometryList.length + 1)}`,
                    width: 1,
                    height: 1,
                    image: ''
                },
                elements: []
            },
            geometricFillPattern: []
        });

        if (this.shape == "triangle") {
            this.currentGeometry.closed = true;
            this.currentGeometry.points = [0, 0, 0, 0, 0];
            this.currentGeometry.sides = 3;
            this.currentGeometry.visible = true;
        }

        this.setDrawingStatusAction(true);
        this.GeometryListAppendAction(this.currentGeometry);
    },
    MudarTamanhoDesenho: function (event) {
        if (!this.drawing) return false;

        var CurrentElement = this.GeometryList.length - 1;
        let posicaoInicialX = this.GeometryList[CurrentElement].x;
        let posicaoInicialY = this.GeometryList[CurrentElement].y;

        var oldScale = event.target.getStage().scaleX();
        var pointer = event.target.getStage().getPointerPosition();

        let posicalMouseX = (pointer.x - event.target.getStage().x()) / oldScale;
        let posicalMouseY = (pointer.y - event.target.getStage().y()) / oldScale;

        let shape = this.GeometryList[CurrentElement].shape;
        var AtualGeometry = this.GeometryList[CurrentElement];

        let DinamicPos = {
            height: posicalMouseY - posicaoInicialY,
            width: posicalMouseX - posicaoInicialX,
        };

        if (shape == "triangle") {
            // RegularPolygon: x,y é o centro e o raio precisa ser positivo
            // (raio negativo desenha o triângulo invertido)
            AtualGeometry.radius = Math.max(Math.abs(DinamicPos.width), Math.abs(DinamicPos.height), 1);
        } else if (shape == "sphere") {
            AtualGeometry.radius = DinamicPos.width < 0 ? 1 : DinamicPos.width;
            AtualGeometry.height = DinamicPos.height < 0 ? 1 : DinamicPos.height;
            AtualGeometry.width = DinamicPos.width < 0 ? 1 : DinamicPos.width;
        } else {
            AtualGeometry.radius = DinamicPos.width;
            AtualGeometry.height = DinamicPos.height;
            AtualGeometry.width = DinamicPos.width;
        }
    },
    FimDesenho: function () {
        const wasDrawing = this.drawing;
        this.setDrawingStatusAction(false);
        if (this.$refs.transformer) {
            this.setKonvaStageAction(this.$refs.transformer.getNode().getStage());
        }
        // A geometria é salva no mousedown ainda com tamanho 0; salva de novo com o tamanho final
        if (wasDrawing) this.updateState();
    },
    Transformer: function (e) {
        if (e.target === e.target.getStage() || e.target.attrs.token == "main") {
            this.selectedShapeName = "";
            this.updateTransformer();
            return;
        }

        const clickedOnTransformer =
            e.target.getParent().className === "Transformer";
        if (clickedOnTransformer) {
            return;
        }

        const token = e.target.attrs.token;
        if (token != "") {
            this.setSelectedTokenAction(token);
        } else {
            this.setSelectedTokenAction("");
        }
        this.updateTransformer();
    },
    updateTransformer: function () {
        const transformerNode = this.$refs.transformer.getNode();
        const stage = transformerNode.getStage();
        var selectedNode = stage.findOne((node) => {
            return node.getAttr("token") === this.selectedToken;
        });

        if (selectedNode === transformerNode.node()) {
            return;
        }

        // Fontes e monitores não têm alças: tamanho e posição são editados no painel
        if (selectedNode && selectedNode.getAttr("class") === "geometry") {
            transformerNode.attachTo(selectedNode);
            transformerNode.rotateEnabled(true);

            if (selectedNode.x() > 600) {
                selectedNode.draggable(false);
            } else {
                selectedNode.draggable(true);
            }

            window.addEventListener("keydown", (e) => {
                if (e.key == "Delete") {
                    this.GeometryListRemove(this.selectedToken);
                    this.updateTransformer();
                }
            });
        } else {
            transformerNode.detach();
        }

        transformerNode.getLayer().batchDraw();
    }
};
export default methods;